import Api from '@/api/api'
import configApi from '@/api/config/_api_config'

async function options(dossier = false) {
    const response = await configApi().post(dossier ? '/medecin/tableau-access' : '/imagerie/access', {}, { med_access_scoped: true, timeout: 20000 })
    const token = response.data && response.data.data && response.data.data.access_token
    if (!token) throw new Error('Accès Imagerie indisponible.')
    return { med_access_scoped: true, timeout: 30000, headers: { [dossier ? 'X-Med-Access' : 'X-Imagerie-Access']: token } }
}
const base = id => '/imagerie/examens/' + encodeURIComponent(id) + '/rapport'
export default {
    async registry() { return (await Api().get('/imagerie/registre', await options())).data.data },
    async get(id, dossier = false) { return (await Api().get(dossier ? base(id).replace('/imagerie/', '/imagerie/dossier/') : base(id), await options(dossier))).data.data },
    async save(id, data) { return (await Api().put(base(id), data, await options())).data.data },
    async validate(id, data) { return (await Api().post(base(id) + '/validation', data, await options())).data.data },
    async models(type) { return (await Api().post('/model-examens/liste', { type_examen_id: type }, { med_access_scoped: true, timeout: 15000 })).data }
}
